/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteFinancialProfileApp} from '../api'

export const useMutationDeleteFinancialProfileApp = createReactQueryMutationHook('deleteFinancialProfileApp', deleteFinancialProfileApp)
